import { Modal } from "react-bootstrap";
import styled from "styled-components";



const ProfileCotainer = styled.div`
display: flex;
${'' /* height:428px; */}
height:${({isContainerHeight})=> isContainerHeight ?  isContainerHeight : '428px'};
flex-direction: column;
padding-bottom: 109px;
${'' /* justify-content: center; */}
${'' /* align-items: center; */}
align-self: stretch;
border-radius: 4px;
border: 1px solid #DCDCDC;
background:  rgba(254, 254, 254, 0.60);
position:relative;



.user-name{
    color: #184A61;
    font-family: Lato;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px; 
    margin-left:33px;
    ${'' /* margin-top:130px; */}
    margin-top: ${({isDataTopMargin})=> isDataTopMargin ?  isDataTopMargin : '130px'};

}

.certificationDetails{
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-top:4px;
  margin-left:33px;
}

.editIcon{
  ${'' /* display: flex;
  width: 40px;
  height: 40px;
  justify-content: flex-end;
  gap: 10px;
  border-radius: 64px;
  background: var(--Vibrant-Coral-100, #FEF4F2); */}

  top: 220px;
  right: 16px;
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  border-radius: 64px;
  background: var(--Vibrant-Coral-100, #FEF4F2);
  cursor: pointer;
  position: absolute;
}

`;


const SpecialityCard = styled.div`
  display: flex;
  mn-width:153px;
  height: 40px;
  padding: 8px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 40px;
  border: 1px solid var(--Bg-Color-for-Light-theme-400, #EFEFEF);
  background: var(--Serene-Blue-200, #E7EEF8);
  ${'' /* margin-left:33px; */}
  ${'' /* margin-top:17px; */}

  .text{
    color: var(--Font-Color-on-Light-theme-500, #184A61);
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
  }

  .icon{
    display: flex;
    width: 24px;
    height: 23.999px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }

`;


const ProfileCircle = styled.div`
display: flex;
${'' /* margin-top:48px; */}
margin-left:24px;
margin-top: ${({isDataMargin})=> isDataMargin ?  isDataMargin : '48px'};
${'' /* width: 330.086px; */}
${'' /* height: 330.086px; */}
width: ${({isData})=> isData ?  isData : '160px'};
height: ${({isData})=> isData ?  isData : '160px'};
${'' /* padding: 105px 35px; */}
flex-direction: column;
justify-content: center;
align-items: center;
gap: 14px;
flex-shrink: 0; 
${'' /* aspect-ratio: 330.09/330.09; */}
border-radius:  83.857px;;
border: 8px solid var(--Bg-Color-for-Light-theme-600, #FEFEFE);
background: var(--Bg-Color-for-Light-theme-500, #F8F8F8);

.nameInitials{
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  text-align: center;
  font-family: Lato;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 126px; 
}



.profile-img{
  width: ${({isData})=> isData ?  isData : '160px'};
  ${'' /* width: 330.086px; */}
  border-radius:  83.857px;;
  border: 8px solid var(--Bg-Color-for-Light-theme-600, #FEFEFE);
}
`;


const NameContainer = styled.div`
color: var(--Font-Color-on-Light-theme-500, #184A61);
text-align: center;
font-family: Lato;
font-size: 84px;
font-style: normal;
font-weight: 700;
line-height: 126px; /* 150% */
`;


const BackgroundImage = styled.div`
height: 200px;
flex-shrink: 0;
border-radius: 4px;
${'' /* background-color:#DDEEDF; */}
${'' /* background: url(<path-to-image>) lightgray 50%; */}
${'' /* cover: no-repeat; */}

  background-image: ${({cover})=> cover ? `url(${cover})`: "none"};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

`;


const CTACard = styled.div`
margin-top:20px;
display: flex;
padding: 20px;
flex-direction: column;
align-items: flex-start;
${'' /* gap: 16px; */}
background: var(--Light-Card, rgba(254, 254, 254, 0.60));

.title{color: var(--Font-Color-on-Light-theme-500, #184A61);
font-family: Lato;
font-size: 24px;
font-style: normal;
font-weight: 700;
line-height: 36px;
}

.subTitle{
    color: var(--Font-Color-on-Light-theme-500, #184A61);
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 133.333% */
}

.progressBar{
    width: 1158px;
    height: 12px;
    background:#EFEFEF;
    margin-top:16px;
}

.completeTitle{
    color:#184A61;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; 
    margin-bottom:4px;
}

.addText{
    color:  #184A61;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
}

.completeProfileContainer{
    display:flex;
    justify-content: center;
    align-items: center;
    gap:16px;
    ${'' /* margin-left:16px; */}
}

`;




const StyledModal = styled(Modal)`
	.modal-dialog{
	display: flex;
    justify-content: center;
    transform: ${({ transform }) => transform && 'translate(0, 80px) translate(0, -90%) !important'};
		.modal-content{
      ${'' /* background:${({ bg }) => bg ? bg : null};  */}
      max-height: ${({ maxHeight }) => maxHeight ? maxHeight : ''};
      width: ${({ newWidth }) => newWidth ? newWidth : '100%'};
	  height: ${({ newHeight }) => newHeight ? newHeight : 'auto'};
	  box-shadow: none;
	  position: absolute;
	  border-radius: 12px;
      ${'' /* padding:16px; */}
			.modal-header {
                padding:16px !important;
                background: ${({ newBg }) => newBg ? newBg : 'white'};
                border-bottom: none !important; /* ✅ Removes header bottom border */
			        	${'' /* border-bottom: ${({ noBorder }) => noBorder ? noBorder : '1px solid #EFEFEF'}; */}
        				border-radius: 6px 6px 0 0;
        				height: ${({ height }) => height ? height : ''};
        				>button{
        				 display: ${({ display }) => display ? display : ''};
        				}
        				.modal-container {
         					width: 100%;
         					display: block;
       				   }
                color:  #184A61;
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
                line-height: 24px; 
			}
			.modal-header .close,
            .modal-header .btn-close {
     				margin-top: -2px;
     				outline: none !important;
     				display: none;
		}
	}}


  .modal-footer{
      ${'' /* background:#F8F8F8; */}
      display:flex;
      flex-direction:row;
      justify-content:center;
      align-items:center;
      border:none;
      padding:0px 16px 16px 16px;


      .wrapper {
       width: 100%;
      display: flex !important;
      justify-content: center !important; 
      align-items: center !important; 
     ${'' /* margin-top: 16px;  */}
      gap:16px;
}
    }
`;




const HeaderText = styled.div`
   display:flex;
   flex-direction:column;
   gap:8px;

   .subContainer{
    display:flex;
    justify-content: space-between;

    .closeIcon{
      cursor:pointer;
    }
   }


   .popupHeading{
    color:  #184A61;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; 
   }

   .popupSubHeading{
    color:  #184A61;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
   }


`;




const StyledTitle = styled.span`
color:  #184A61;
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px; 
>svg{
	display:flex;
	margin:auto 0px auto auto;
}
`;

const StyledBody = styled(Modal.Body)`
width: 100%;
flex: 1; 
max-height: 100%; 
overflow-y:${({isOverFlow})=> isOverFlow ? isOverFlow : "auto" };
 font-family:Lato;
 padding:16px;

 .wrapper {
   width: 100%;
  display: flex !important;
  justify-content: center !important; 
  align-items: center !important; 
  margin-top: 16px; 
  gap:16px;
}


.min-max-text{
color: var(--Font-Color-on-Dark-theme-100, #989898);
font-family: Lato;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
margin-top:4px;
}


&::-webkit-scrollbar {
    width: 5px; /* scrollbar width */
    height:10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #BDBDBD; /* scrollbar thumb color */
    border-radius: 5.5px; /* rounded scrollbar thumb */
    min-height: 20px; 
    width: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #BDBDBD; /* darker on hover */
  }

  &::-webkit-scrollbar-track {
    background-color: #EFEFEF; /* track color */
    border-radius: 5.5px;
  }

`;




const StyledTextArea = styled.textarea`
  border: none;
  padding:${({ isPadding }) => isPadding ? isPadding : ' 0px 12px 0px 12px'};
  box-shadow: none;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: ${({ margin }) => margin ? margin : '0px'};
  height: ${({ height }) => height ? height : '48px'};
  font-family: Lato;
  resize:none;
  overflow-y:${({ isOverFlow }) => isOverFlow ? isOverFlow : 'auto'};
  font-weight:500;
  width: 100%;
  border-radius:6px;
  color:${({ color, disabled, updatedColor }) => updatedColor?updatedColor: color && !disabled ? color : disabled ? '#BDBDBD' : '#184A61'};
  background-color:${({ bgColor, disabled }) => bgColor ? bgColor : disabled ? '#EFEFEF' : 'white'};
  cursor: ${({ disabled }) => disabled && 'not-allowed !important'};
  border:${({ border,isBorderColor }) => border ? border : isBorderColor ? isBorderColor : '1px solid #BDBDBD'};

  /* Hide number input arrows */
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type="number"] {
    -moz-appearance: textfield; /* Firefox */
  }

  &:active{
    ${'' /* border:${({ border }) => border ? border : '1px solid rgba(0, 92, 135)'}; */}
  }
  &::placeholder {
    color:${({ pColor }) => pColor ? pColor : '#BDBDBD'};
    vertical-align: middle;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; 
  }

  white-space: pre-wrap;
  word-wrap: break-word;

  &:focus, &:active {
    ${'' /* outline: 1px solid #005C87; */}
    // outline:${({ bordercolor }) => bordercolor ? bordercolor : '1px solid #005C87'};
    border:none !important;
    outline:${({ border, isBorderColor }) => isBorderColor?isBorderColor: border ? border : '1px solid rgba(0, 122, 177, 0.30)'};
    border:${({ border, isBorderColor }) => isBorderColor?isBorderColor: border ? border : '1px solid rgba(0, 122, 177, 0.30)'};
    ${'' /* outline-color:#005c87; */}
  }


  &::-webkit-scrollbar {
    width: 4px; /* scrollbar width */
  }

  &::-webkit-scrollbar-thumb {
    background-color: #BDBDBD; /* scrollbar thumb color */
    border-radius: 5.5px; /* rounded scrollbar thumb */
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #BDBDBD; /* darker on hover */
  }

  &::-webkit-scrollbar-track {
    background-color: #EFEFEF; /* track color */
    border-radius: 5.5px;
  }
`;







const StyledTextAreaAutoSize = styled.textarea`
  border: none;
  padding: ${({ isPadding }) => isPadding ? isPadding : '0px 12px'};
  box-shadow: none;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: ${({ margin }) => margin || '0px'};
  font-family: Lato;
  resize: none;
  overflow-y: auto;
  font-weight: 500;
  width: 100%;
  border-radius: 6px;
  min-height: 48px;
  ${'' /* height:48px; */}
  height: ${({ isHeight }) => isHeight ? isHeight : '48px'};
  max-height: ${({ isMaxHeight }) => isMaxHeight ? isMaxHeight : '604px'};
  ${'' /* max-height: 604px; */}
  color: ${({ color, disabled, updatedColor }) =>
    updatedColor ? updatedColor : color && !disabled ? color : disabled ? '#BDBDBD' : '#184A61'};
  background-color: ${({ bgColor, disabled }) =>
    bgColor ? bgColor : disabled ? '#EFEFEF' : 'white'};
  cursor: ${({ disabled }) => disabled && 'not-allowed !important'};
  border: ${({ border, isBorderColor }) => border || isBorderColor || '1px solid #BDBDBD'};

  &::placeholder {
    color: ${({ pColor }) => pColor || '#BDBDBD'};
    font-family: Lato;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
  }

  white-space: pre-wrap;
  word-wrap: break-word;
  ${'' /* overflow:hidden; */}

 


  &:focus, &:active {
    border:none !important;
    outline:${({ border, isBorderColor }) => isBorderColor?isBorderColor: border ? border : '1px solid rgba(0, 122, 177, 0.30)'};
    border:${({ border, isBorderColor }) => isBorderColor?isBorderColor: border ? border : '1px solid rgba(0, 122, 177, 0.30)'};
  }

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #BDBDBD;
    border-radius: 5.5px;
  }

  &::-webkit-scrollbar-track {
    background-color: #EFEFEF;
    border-radius: 5.5px;
  }
`;


const CommonButtonPopup = styled.button`
width: ${({width}) => width ? width : '200px'};
height: ${({height}) => height ? height : '40px'};
display:flex;
justify-content:center;
align-items:center;
padding: ${({padding}) => padding ? padding : '12px 16px'};
margin: ${({margin}) => margin ? margin : '0px'};
border-radius: 6px;
background-color: ${({disabled, background}) => disabled ? '#EFEFEF' : background ? background:  '#DA6C74'};
color: ${({disabled, color}) =>disabled ? '#989898' : color?color: '#FEFEFE'};
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
cursor: ${({disabled}) =>  disabled ?'not-allowed !important': 'pointer'};
${'' /* cursor:pointer; */}
gap: 8px;
border:none;
>svg{
  width:16px;
  height:16px;
}
`;


const CommonButtonBorder = styled.div`
width: ${({width}) => width ? width : '200px'};
height: ${({height}) => height ? height : ''};
display:flex;
justify-content:center;
align-items:center;
padding: ${({padding}) => padding ? padding : '12px 16px'};
margin: ${({margin}) => margin ? margin : '0px'};
border-radius: 4px;
background-color: transparent;
color: #184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
cursor:pointer;
border: 1px solid #DA6C74;
gap: 8px;
>svg{
  width:16px;
  height:16px;
}
`;



const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
`;



const ProfileImageContainer = styled.div`
display: flex;
height:182px;
width: 182px;
padding: 48.5px 48.5px;
justify-content: center;
align-items: center;
border-radius: 4px;
border: 1px solid var(--Bg-Color-for-Light-theme-200, #BDBDBD);








.iconContainer{
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
}

.middle-section {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex-direction: column;
  }

.title {
    color: #184A61;
    text-align: center;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    margin-top: 4px;
    text-transform: capitalize;
  }

  .sub-title {
    color: #184A61;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    text-transform: lowercase;
  }

`;





const PreviewImage = styled.div`
  display: flex;
  height: 182px;
  width: 182px;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--Bg-Color-for-Light-theme-200, #BDBDBD);
  overflow: hidden; /* ✅ ensures no overflow */
  background-color: #fff; /* optional, keeps it clean */

  img {
    width: 100%; /* ✅ fills the container */
    height: 100%;
    object-fit: contain; /* ✅ keeps aspect ratio */
  }
`;



const WellbeingPillarContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  width: 100%;
  max-width: 600px; /* make sure we have enough width for 2 cards */
  margin: 0 auto; /* center in modal */
`;



const WellbeingPillarsCard = styled.div`
display: flex;
${'' /* width: 276px; */}
width: ${({isWidth} ) => isWidth ? isWidth : '276px'};
padding: 12px 8px;
align-items: center;
gap: 12px;
border-radius: 4px;
border: 0.5px solid var(--Bg-Color-for-Light-theme-400, #EFEFEF);
${'' /* background: var(--Bg-Color-for-Light-theme-500, #F8F8F8); */}
backdrop-filter: blur(40px);


.checkBox{
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid var(--Bg-Color-for-Light-theme-50, #7C7C7C);
}

.wellbeing-text{
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  ${'' /* font-weight: 700; */}
  font-weight:${({isFontWeight}) => isFontWeight ? isFontWeight : '700'};
  line-height: 20px; /* 125% */
}


`


const CustomCheckBox = styled.div`
  width: 20px;
  height: 20px;
  border: ${({ isBorder }) => (isBorder ? isBorder : " 1px solid #BDBDBD")};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: ${({ selected }) => (selected ? "white" : "transparent")};
  background: ${({ isBgColor }) => (isBgColor ? isBgColor : "white")};
  transition: all 0.2s ease-in-out;

  .tickIcon{
    display:flex;
    justify-content:center;
    align-items:center;
  }
`;



const AboutContainer = styled.div`
display: flex;
padding: ${({isPadding}) => isPadding ? isPadding : '20px '};
flex-direction: column;
align-items: flex-start;
width:${({isWidth})=> isWidth ? isWidth : '100%'};
${'' /* gap: 28px; */}
margin-top: ${({marginTop}) => marginTop ? marginTop : '20px'};
${'' /* margin-top:24px; */}
align-self: stretch;
border-radius: 4px;
border: 1px solid var(--Bg-Color-for-Light-theme-300, #DCDCDC);
background: var(--LightCard, rgba(254, 254, 254, 0.60));

.aboutSubContainer{
  align-items:center;
  ${'' /* width:${({isWidth})=> isWidth ? isWidth : '100%'}; */}
  width:100%;
  display:flex;
  justify-content: space-between;
  margin-bottom: ${({marginBottom}) => marginBottom ? marginBottom : '16px'};
}

.aboutHeading{
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  font-family: Lato;
  ${'' /* font-size: 24px; */}
  font-size:${({isFontSize})=> isFontSize ? isFontSize : "24px"}
  font-style: normal;
  font-weight: 700;
  line-height: 36px; 
}

.heading{
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; 
}
.subHeading{
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; 
}



.text{
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; 
  word-break:break-word;
}

.no-Data-Found{
  color: #BDBDBD;
  text-align: center;
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; 
  margin:auto;
}

.icon{
  cursor:pointer;
}


.no-data{
color: var(--Font-Color-on-Dark-theme-200, #BDBDBD);
text-align: center;
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 400;
line-height: 24px; /* 133.333% */
margin:auto;
}

`;


const TagUserCard = styled.div`
  display: flex;
  height:24px;
  align-items: center;
  background-color: #FEFEFE;
  padding: 4px;
  border-radius: 40px;
  border: 1px solid  #EFEFEF;

  .name {
    margin-right: 4px;
    color:  #184A61;
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; 
  }
`;



const StyledInput = styled.input`
  border: none;
  padding:${({ isPadding }) => isPadding ? isPadding : ' 0px 12px 0px 12px'};
  ${'' /* padding: 0px 20px 0px 20px; */}
  box-shadow: none;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: ${({ margin }) => margin ? margin : '0px'};
  height: ${({ height }) => height ? height : '48px'};
  ${'' /* height: 48px; */}
  font-family: Lato;
  font-weight:500;
  width: 100%;
  border-radius:6px;
  color:${({ color, disabled, updatedColor }) => updatedColor?updatedColor: color && !disabled ? color : disabled ? '#BDBDBD' : '#184A61'};
  ${'' /* border:${({ border }) => border ? border : 'rgba(0, 122, 177, 0.30)'}; */}
  background-color:${({ bgColor, disabled }) => bgColor ? bgColor : disabled ? '#EFEFEF' : 'white'};
  cursor: ${({ disabled }) => disabled && 'not-allowed !important'};
  border:${({ border,isBorderColor }) => border ? border : isBorderColor ? isBorderColor : '1px solid #BDBDBD'};

  /* Hide number input arrows */
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type="number"] {
    -moz-appearance: textfield; /* Firefox */
  }

  &:active{
    ${'' /* border:${({ border }) => border ? border : '1px solid rgba(0, 92, 135)'}; */}
  }
  &::placeholder {
    color:${({ pColor }) => pColor ? pColor : '#BDBDBD'};
    vertical-align: middle;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
  }

  &:focus, &:active {
    ${'' /* outline: 1px solid #005C87; */}
    // outline:${({ bordercolor }) => bordercolor ? bordercolor : '1px solid #005C87'};
    border:none !important;
    outline:${({ border, isBorderColor }) => isBorderColor?isBorderColor: border ? border : '1px solid rgba(0, 122, 177, 0.30)'};
    border:${({ border, isBorderColor }) => isBorderColor?isBorderColor: border ? border : '1px solid rgba(0, 122, 177, 0.30)'};
    ${'' /* outline-color:#005c87; */}
  }


  &:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
  -webkit-text-fill-color: #184A61 !important;
}

&::selection {
  background: white;
  color: #184A61;
}
`;


const MomentCaption = styled.div`
  color:  #184A61;
  margin-top:8px;
  margin-bottom:16px;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
`;

export { ProfileCotainer,ProfileCircle,NameContainer,BackgroundImage,CTACard,StyledModal,StyledTitle,StyledBody,HeaderText,CommonButtonPopup,CommonButtonBorder,Wrapper,StyledTextArea,StyledTextAreaAutoSize,ProfileImageContainer,PreviewImage,WellbeingPillarContainer,WellbeingPillarsCard,CustomCheckBox,AboutContainer,SpecialityCard,TagUserCard,StyledInput,MomentCaption};